import React, { Component } from 'react';
import { Col, FormGroup } from 'reactstrap';
// eslint-disable-next-line
import { resourceData } from '../../../Resources/EULA/EULA.en-US'


export default class EmployeeLicenseTerms extends Component {

    componentWillMount() {
        import('../../../Resources/EULA/EULA.en-US').then((resourceData) => {
            this.setState({
                license_content: resourceData.resourceData
            });
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            license_content: ""
        }
    }


    render() {
        var CloseModal = this.props.CloseModal;
        let { license_content } = this.state
        let license_content_data = license_content;

        return (
            <div className="emp_license_Modal">
                <div className="license_Modal_content_box">
                    <div className="license_header">
                        <h2 className="license_header_name">Trane Facility Services License Agreement</h2>
                    </div>

                    <div className="EULAcontent">
                        <textarea className="emp_license_Content" readOnly="readonly" value={license_content_data} ></textarea>
                    </div>

                        <FormGroup row >
                            <Col sm={{ size: 1,  offset: 11 }}>
                            <h2 className="link_cursor close_link" onClick={() => CloseModal('Cancel')}>CLOSE</h2>
                            </Col>
                        </FormGroup>
                </div>
            </div>
        );
    }
}



